<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar>
          <checkbox label-size="xs" :icon-color="$root.$colors.primary" :label="$lang.prevNextButtons" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="prevNextButtons" /><!--
          --><checkbox label-size="xs" :icon-color="$root.$colors.primary" :label="$lang.firstLastButtons" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="firstLastButtons" /><!--
          --><dropdown :class="['mx-1']" :items="alignments" v-model="align" width="128px" :ripple-color="$dark ? 'white' : 'gray'" :ripple-color-lightness="$dark ? null : 300" :color="$root.$colors.primary" :color-lightness="$root.$colors.bgColorLightness" />
        </test-toolbar>
      </flex-col>
      <flex-col :span="24">
        <card>
          <card-text>
            <pager
              @input="log('input', 'pager', $event)"
              v-model="page"
              :align="align[0]"
              color="white"
              selected-bg-color="black"
              :color-lightness="null"
              :bg-color="$root.colors.primary"
              :bg-color-lightness="$root.colors.bgColorLightness"
              :selected-bg-color-lightness="null"
              :prev-next-buttons="prevNextButtons"
              :first-last-buttons="firstLastButtons"
              :count="count" />
          </card-text>
        </card>
      </flex-col>
    </flex>
  </container>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'PagePager',
  mixins: [
    methods
  ],
  data () {
    return {
      page: 0,
      count: 5,
      align: ['center'],
      firstLastButtons: true,
      prevNextButtons: true,
      alignments: ['left', 'center', 'right'].map(value => {
        return {
          value,
          text: this.firstLetterCapital(value)
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/ui/pager.vue